import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ServicesHero from "./components/ServicesHero";
import ServiceRegistration from "./components/ServiceRegistration";
import ServiceCompliance from "./components/ServiceCompliance";
import ServiceInvestment from "./components/ServiceInvestment";
import ServiceTender from "./components/ServiceTender";

export default function ServicesPage() {
  return (
    <main>
      <Helmet>
        <title>Our Services | Company Registration, Compliance & Investment Facilitation | AIP</title>
        <meta name="description" content="AIP offers end-to-end business services in East Africa: company registration, regulatory compliance, foreign direct investment facilitation, and tender support across Rwanda, Kenya, Uganda, and Tanzania." />
        <meta name="keywords" content="company registration East Africa, regulatory compliance Africa, FDI facilitation, tender support East Africa, business registration Rwanda, business registration Kenya, investment services Africa" />
        <link rel="canonical" href="https://africainvestmentportal.com/services" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Services | Company Registration & Investment Facilitation in East Africa" />
        <meta property="og:description" content="End-to-end business services in East Africa: company registration, compliance, FDI facilitation, and tender support." />
        <meta property="og:url" content="https://africainvestmentportal.com/services" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Services | Company Registration & Investment Facilitation in East Africa" />
        <meta name="twitter:description" content="End-to-end business services in East Africa: company registration, compliance, FDI facilitation, and tender support." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Services | Company Registration & Investment Facilitation in East Africa",
          "url": "https://africainvestmentportal.com/services",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://africainvestmentportal.com" },
              { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://africainvestmentportal.com/services" }
            ]
          }
        })}</script>
      </Helmet>
      <Navbar />
      <ServicesHero />
      <ServiceRegistration />
      <ServiceCompliance />
      <ServiceInvestment />
      <ServiceTender />
      <Footer />
    </main>
  );
}
